import Button from '@atlaskit/button/standard-button';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { N800 } from '@atlaskit/theme/colors';
import { pluralize } from '@atlassian/mpac-utils';
import React from 'react';
import Image from "../../../../Image";
import { BackgroundUnderlay, Caption, Container, Content, H3, ImageContainer, ShortcutIconWrapper } from "./Gallery.styles";
const Gallery = props => {
  const firstScreenshot = props.screenshots[0];
  const handleClick = () => props.onMediaClick(firstScreenshot);
  const icon = /*#__PURE__*/React.createElement(ShortcutIconWrapper, null, /*#__PURE__*/React.createElement(ShortcutIcon, {
    label: "",
    primaryColor: N800,
    size: "small"
  }));
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(BackgroundUnderlay, null), /*#__PURE__*/React.createElement(H3, null, "Gallery"), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(ImageContainer, null, /*#__PURE__*/React.createElement(Image, {
    image: firstScreenshot.image,
    onClick: handleClick,
    loading: "lazy"
  })), /*#__PURE__*/React.createElement("div", null, firstScreenshot.caption && /*#__PURE__*/React.createElement(Caption, null, " ", firstScreenshot.caption), /*#__PURE__*/React.createElement(Button, {
    appearance: "link",
    onClick: handleClick,
    spacing: "none",
    iconAfter: icon
  }, pluralize('image', props.screenshots.length + props.highlights.length, true)))));
};
export default Gallery;